export default {
  setup () {
    this.fillCookie()
  },

  createCookie (name, value, days, path, domain, secure) {
    var cookieDomain, cookieExpire, cookiePath, cookieSecure, date, expireDate
    expireDate = null
    if (days) {
      date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expireDate = date
    }
    cookieExpire =
    expireDate != null ? '; expires=' + expireDate.toGMTString() : ''
    cookiePath = path != null ? '; path=' + path : '; path=/'
    cookieDomain = domain != null ? '; domain=.' + domain : '; domain=.' + window.location.hostname
    cookieSecure = secure ? '; secure' : ''
    document.cookie =
      name +
      '=' +
      value +
      cookieExpire +
      cookiePath +
      cookieDomain +
      cookieSecure
  },

  readCookie (name) {
    var c, ca, i, nameEQ
    nameEQ = name + '='
    ca = document.cookie.split(';')
    i = 0
    while (i < ca.length) {
      c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length)
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length)
      }
      i++
    }
    return null
  },

  getUtmParams () {
    return {
      utm_id: this.readCookie('utm_id'),
      utm_source: this.readCookie('utm_source'),
      utm_medium: this.readCookie('utm_medium'),
      utm_campaign: this.readCookie('utm_campaign'),
      utm_term: this.readCookie('utm_term'),
      utm_content: this.readCookie('utm_content'),
      utm_user: this.readCookie('utm_user'),
      utm_referrer: this.readCookie('utm_referrer')
    }
  },

  fillCookie () {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const utmId = urlParams.get('utm_id')
    const utmSource = urlParams.get('utm_source')
    const utmMedium = urlParams.get('utm_medium')
    const utmCampaign = urlParams.get('utm_campaign')
    const utmTerm = urlParams.get('utm_term')
    const utmContent = urlParams.get('utm_content')
    const utmReferrer = document.referrer

    if (utmId != null) {
      this.createCookie('utm_id', utmId, 1)
    }

    if (utmSource != null) {
      this.createCookie('utm_source', utmSource, 1)
    }

    if (utmMedium != null) {
      this.createCookie('utm_medium', utmMedium, 1)
    }

    if (utmCampaign != null) {
      this.createCookie('utm_campaign', utmCampaign, 1)
    }

    if (utmTerm != null) {
      this.createCookie('utm_term', utmTerm, 1)
    }

    if (utmContent != null) {
      this.createCookie('utm_content', utmContent, 1)
    }

    if (utmReferrer != null) {
      this.createCookie('utm_referrer', utmReferrer, 1)
    }

    if (this.readCookie('utm_user') === null) {
      const timestamp = new Date().getTime()
      const random = Math.floor(Math.random() * timestamp)
      this.createCookie('utm_user', random, 1)
    }
  }
}
